import { render, staticRenderFns } from "./publication.vue?vue&type=template&id=3b1fcc90&scoped=true&"
import script from "./publication.vue?vue&type=script&lang=js&"
export * from "./publication.vue?vue&type=script&lang=js&"
import style0 from "./publication.vue?vue&type=style&index=0&id=3b1fcc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1fcc90",
  null
  
)

export default component.exports